<onyx-modal
  variant="center"
  [heading]="`${I18N}.${data.mode}GoodType`"
  [close$]="close$"
  (closeModal)="dialogRef.close()"
>
  <form [formGroup]="form" [onyxAutoFocus]="data.mode">
    @let controls = form.controls;
    <app-dictionaries-names-translation-form
      [form]="controls.names"
      label="labels.goodType"
      [initialValue]="data.mode === OnyxFormMode.ADD ? data.name : undefined"
    ></app-dictionaries-names-translation-form>

    <onyx-dropdown
      [formControl]="controls.relatedUnits"
      label="labels.relatedUnits"
      [options]="companyUnits$ | async"
      [multiple]="true"
      [search]="true"
    ></onyx-dropdown>

    <div class="group">
      <onyx-dropdown
        [formControl]="controls.adrClass"
        label="labels.adrClass"
        [options]="adrClasses$ | async"
        [optional]="true"
        [search]="true"
      ></onyx-dropdown>
    </div>
  </form>

  <ng-container bottomRightOptions>
    <onyx-button variant="outlined" (click)="close$.next()">
      {{ 'labels.cancel' | translate }}
    </onyx-button>

    <onyx-button [spinner]="loading()" (click)="!loading() ? submit() : null">
      {{
        `labels.${data.mode === OnyxFormMode.ADD ? 'add' : 'saveChanges'}`
          | translate
      }}
    </onyx-button>
  </ng-container>
</onyx-modal>
